export default function PHP_ob_gzhandler() {
  return (
    <div>
      <h1>PHP_ob_gzhandler</h1>
    </div>
  );
}
